<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>destacar un titular de premsa</strong>.
    </p>
    <p>
      Recomanem usar la <strong>foto que acompanya la notícia</strong> i, en cas de no tindre prou resolcuió, buscar-ne una de similar.
    </p>
    <p>
      Sel·leccioneu una font del llistat, o introduiu-ne una manualment si no la trobeu al llistat (publicacions locals o d'àmbit reduït). Ens podeu suggerir
      afegir una font utilitzant el formulari que hi ha més avall.
    </p>
    <p>
      És pot afegir, si és adient, un hashtag relacionat amb la temàtica, així com el nom del col·lectiu al costat del logo, utilizant els camps "hashtag" i "afegir text al logo".
    </p>
    <p>
      Aquest model de tarja accepta els següents formats:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, Twitter, canals de Telegram i Whatsapp, etc.). Aquest model compta amb dues disposicions. És recomana alternar entre les dues si publiqueu amb freqüència.</li>
      <li><strong>9:16</strong>: model per a stories (Instagram, Facebook, Whatsapp). Aquest model no inclou el logo de Comporomís perquè ja és mostra a la part superior esquerra quan es comparteix en l'aplicació.</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
      <img src="./examples/916.png" alt="Exemple 9:16" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'event-help'
}
</script>
